<div>
  <form [formGroup]="formGroup" class="flex flex-column gap-4">
    <!-- Logo Upload Section -->
    <div class="flex flex-column gap-2">
      <label for="logo" class="font-medium">Logo de l'institution <span class="text-red-500">*</span></label>
      <div class="flex align-items-start gap-3 p-3 border-1 surface-border border-round">
        <!-- Upload Info & Button -->
        <div class="flex-1">
          <!-- File Upload for Create Mode -->
          <div *ngIf="isCreate">
            <p-fileUpload
              class="custom-file-upload-compact"
              (onSelect)="onUpload($event)"
              [showUploadButton]="false"
              [showCancelButton]="false"
              [multiple]="false"
              accept="image/*"
              [maxFileSize]="maxFileSize"
              chooseLabel="Choisir un fichier"
              chooseIcon="pi pi-upload"
              styleClass="p-button-sm">
            </p-fileUpload>

            <div *ngIf="uploadedFiles.length > 0" class="mt-2">
              <small class="text-green-600">
                <i class="pi pi-check-circle mr-1"></i>
                <strong>{{ uploadedFiles[0].name }}</strong> ({{ (uploadedFiles[0].size / 1024).toFixed(0) }} KB)
              </small>
            </div>
          </div>

          <!-- File Upload for Edit Mode -->
          <div *ngIf="boundData?.isEdit">
            <p-fileUpload
              mode="basic"
              chooseLabel="Modifier le logo"
              chooseIcon="pi pi-upload"
              [multiple]="false"
              accept="image/*"
              [maxFileSize]="maxFileSize"
              (onSelect)="onLogoUpdate($event)"
              styleClass="p-button-outlined p-button-sm" />
          </div>
        </div>

        <!-- Preview Avatar -->
        <div class="logo-preview-container">
          <p-avatar
            [image]="logoPreview || boundData?.data?.logoUrl || 'assets/default-institution.png'"
            styleClass="org-avatar shadow-2"
            [style]="{ 'width': '80px', 'height': '80px', 'border': '2px solid var(--surface-border)' }"
            shape="circle" />
          <div *ngIf="uploadedFiles.length > 0" class="logo-badge">
            <i class="pi pi-check text-white"></i>
          </div>
        </div>
      </div>
      <small *ngIf="!fileError" class="text-500">
        JPG, PNG, GIF, WEBP • Max {{ maxFileSize / 1000000 }}MB
      </small>
      <small *ngIf="fileError" class="text-red-600">
        <i class="pi pi-exclamation-triangle mr-1"></i>{{ fileError }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="type" class="font-medium">Type de l'institution <span class="text-red-500">*</span></label>
      <p-select id="type" aria-describedby="type-help" formControlName="type" [editable]="true"
                  [options]="types" placeholder="Type d'organisation"
                  [ngClass]="{'ng-invalid ng-dirty': hasFieldError('type')}" />
      <small *ngIf="isCreate && !hasFieldError('type')" id="type-help" class="text-gray-600">
        Renseigner ici le type d'institution créé.
      </small>
      <small *ngIf="hasFieldError('type')" class="text-red-500">
        {{ getFieldError('type') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <p-multiSelect [options]="modules" formControlName="modules" optionLabel="description" optionValue="id"
                     [disabled]="productsDisabled" placeholder="Sélectionner les modules activés"/>
    </div>
    <div class="flex flex-column gap-2">
      <label for="name" class="font-medium">Nom <span class="text-red-500">*</span></label>
      <input pInputText id="name" aria-describedby="name-help" formControlName="name"
             [ngClass]="{'ng-invalid ng-dirty': hasFieldError('name')}" />
      <small *ngIf="isCreate && !hasFieldError('name')" id="name-help" class="text-gray-600">
        Renseigner ici le nom de l'institution (2-100 caractères).
      </small>
      <small *ngIf="hasFieldError('name')" class="text-red-500">
        {{ getFieldError('name') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="email" class="font-medium">Email <span class="text-red-500">*</span></label>
      <input pInputText id="email" aria-describedby="email-help" formControlName="email" type="email"
             [ngClass]="{'ng-invalid ng-dirty': hasFieldError('email')}" />
      <small *ngIf="isCreate && !hasFieldError('email')" id="email-help" class="text-gray-600">
        Renseigner ici l'adresse email de l'institution.
      </small>
      <small *ngIf="hasFieldError('email')" class="text-red-500">
        {{ getFieldError('email') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="phone" class="font-medium">Téléphone <span class="text-red-500">*</span></label>
      <input pInputText id="phone" aria-describedby="phone-help" formControlName="phone" type="tel"
             [ngClass]="{'ng-invalid ng-dirty': hasFieldError('phone')}" />
      <small *ngIf="isCreate && !hasFieldError('phone')" id="phone-help" class="text-gray-600">
        Ex: +221 33 860 00 00
      </small>
      <small *ngIf="hasFieldError('phone')" class="text-red-500">
        {{ getFieldError('phone') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="address" class="font-medium">Adresse</label>
      <input pInputText id="address" aria-describedby="address-help" formControlName="address"
             [ngClass]="{'ng-invalid ng-dirty': hasFieldError('address')}" />
      <small *ngIf="isCreate && !hasFieldError('address')" id="address-help" class="text-gray-600">
        Renseigner ici l'adresse de l'institution (max 200 caractères).
      </small>
      <small *ngIf="hasFieldError('address')" class="text-red-500">
        {{ getFieldError('address') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="country" class="font-medium">Pays <span class="text-red-500">*</span></label>
      <p-select
        [disabled]="boundData?.isView || false"
        [options]="countries"
        formControlName="country"
        optionLabel="country"
        editable="true"
        id="country"
        optionValue="country"
        [showClear]="true"
        [ngClass]="{'ng-invalid ng-dirty': hasFieldError('country')}"
        placeholder="Choisir un pays">
        <ng-template let-country pTemplate="item">
          <div class="flex align-items-center gap-2">
            <img alt="{{ country.country }}"
              src="https://purecatamphetamine.github.io/country-flag-icons/3x2/{{ country.code | uppercase }}.svg"
              style="width: 18px" />
            <div>{{ country.country }}</div>
          </div>
        </ng-template>
      </p-select>
      <small *ngIf="!hasFieldError('country')" id="country-help" class="text-gray-600">
        Sélectionner le pays de l'institution.
      </small>
      <small *ngIf="hasFieldError('country')" class="text-red-500">
        {{ getFieldError('country') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="description" class="font-medium">Description</label>
      <textarea id="description" rows="5" cols="30" pTextarea formControlName="description"
                [ngClass]="{'ng-invalid ng-dirty': hasFieldError('description')}"
                placeholder="Description de l'institution..."></textarea>
      <small *ngIf="!hasFieldError('description')" class="text-gray-600">
        Description optionnelle (max 500 caractères).
      </small>
      <small *ngIf="hasFieldError('description')" class="text-red-500">
        {{ getFieldError('description') }}
      </small>
    </div>

    <div class="flex gap-2 justify-content-end">
      <p-button *ngIf="!isCreate" pRipple [severity]="boundData?.data.state == 'ACTIVE' ? 'danger' : 'success'"
                [label]="boundData?.data.state == 'ACTIVE' ? 'Désactiver' : 'Activer'"
                (onClick)="toggleInstitution()"></p-button>
      <p-button pRipple *ngIf="!formGroup.disabled" [style]="{width: '100%'}"
                [label]=" isCreate  ? 'Enregistrer' : 'Modifier'" [disabled]="!formGroup.valid"
                [loading]="isLoading" (onClick)="isCreate ? create() : update()"></p-button>
    </div>
  </form>
</div>
